import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { SchedulingLink, SchedulingLinksParams } from '@/types/schedulingLink';
import ajax from '@/utils/ajax';

export const schedulingLinksRepository = {
  BASE_URL: '/api/dugout/scheduling_links/',

  async getSchedulingLinks({
    host,
    personId,
    params
  }: {
    host: string;
    personId: string;
    params: SchedulingLinksParams;
  }): Promise<SchedulingLink[]> {
    const response = await ajax.get({
      url: `${host}${this.BASE_URL}${personId}`,
      params
    });

    return response.data;
  }
};

const SchedulingLinksRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async getSchedulingLinks(
      personId: string,
      params: SchedulingLinksParams
    ): Promise<SchedulingLink[]> {
      return schedulingLinksRepository.getSchedulingLinks({
        host,
        personId,
        params
      });
    }
  };
};

export default SchedulingLinksRepository;
